import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Paginator } from "primereact/paginator";
import useUserStore from "../../../../utils/storeApp";
import CallAPI from "../../../../services/apiCalls";
import { Column } from "primereact/column";
import $ from "jquery";
import { useReactToPrint } from "react-to-print";
import ReportsDropdown from "../ReportsDropdown";
import * as moment from "moment";
import { CSVLink } from "react-csv";
import SharedMsg from "../../SharedMsg";

const ListUserActivity = () => {
  const navigate = useNavigate();
  const { isUserLogedIn, userRole, userToken, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  const [userObj, setUserObj] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [activityHistory, setActivityHistory] = useState({});
  const [count, setCount] = useState(0);
  const [refreshObj, SetRefreshObj] = useState(false);
  const [processing, SetProcessing] = useState(false);
  const [submInputFlag, setSubmitInputFlag] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  useEffect(() => {
    let obj = sharedObject.UserActiviySearch;
    if (obj && Object.keys(obj).length > 0) {
      setLast(obj.count < 25 ? obj.count : 25);
      gridData(obj);
    }
  }, [sharedObject.UserActiviySearch]);
  const getReport = async (src, pg) => {
    SetProcessing(true);
    let call =
      "/reports/UserActivity?searchPhrase=''&sortDir=SentDate&sortBy=SentDate&current=" +
      pg;
    SetRefreshObj(src);
    const res = await CallAPI(call, src, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      gridData(res.data.data);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const gridData = (obj) => {
    let cnt = obj.count;
    setCount(cnt);
    let tempObj = [];
    for (const row of obj.pageItems) {
      let cs = (
        <a
          href="javascript:void(0);"
          underline="none"
          className="font-weight-bold"
          onClick={() => {
            userHistory(row);
          }}
        >
          {row.userNameDisplay}
        </a>
      );
      row.nameDisplay = cs;
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };
  const userHistory = async (el) => {
    setActivityHistory(el);
    const yourDate = new Date();
    const NewDate = moment(yourDate).format("MM/DD/YYYY");
    let lastYear = moment().subtract(1, "year");

    let search = {
      EventDomain: el.domainName,
      EventValue: el.userName,
      StartDate: new Date(lastYear),
      EndDate: new Date(NewDate),
    };
    SetProcessing(true);
    let call =
      "/reports/UserHistory?current=1&sortDir=SentDate&sortBy=SentDate";
    const res = await CallAPI(call, search, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setHistoryData(res.data.data.pageItems);
      let obj = {
        ...search,
        List: res.data.data.pageItems,
        Name: el.accountName,
      };
      SetSharedObject("UserActiviyHistory", obj);
      navigate("/user-account-history");
      //$("#FlReportModal").modal("show");
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const sentMessageTemplate = (dt) => {
    return dt.dateLastLogin
      ? new Date(dt.dateLastLogin).toLocaleString()
      : null;
  };
  const formatDateAccepted = (dt) => {
    return dt.dateModified ? new Date(dt.dateModified).toLocaleString() : null;
  };
  const formatDateConfirmed = (dt) => {
    return dt.dateCreated ? new Date(dt.dateCreated).toLocaleString() : null;
  };
  const [first, setFirst] = useState(1);
  const [last, setLast] = useState(25);
  const [rows, setRows] = useState(25);
  const onPageChange = (event) => {
    setFirst(event.first + 1);
    setRows(event.rows);
    let lastNr = event.first + 25;
    let last = lastNr > count ? count : lastNr;
    setLast(last);
    let page = event.page + 1;
    SetRefreshObj(sharedObject.messageStatusSearch);
    getReport(sharedObject.messageStatusSearch, page);
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    setFirst(1);
    setLast(25);
    getReport(sharedObject.messageStatusSearch, 1);
  };
  const downLoad = () => {
    $("#InputDownloadModal").modal("show");
  };
  const bulkDownLoad = () => {
    SetSharedObject("UserActiviyType", "bulk");
    $("#userActivitySearchModal").modal("show");
  };
  const QueueDownload = async () => {
    let obj = sharedObject.messageStatusSearch;
    let o = [
      {
        Key: parseInt(obj.OrganizationId),
        Value: obj.OrganizationName,
      },
    ];
    let refObj = { ...obj, OrgList: JSON.stringify(o) };
    SetProcessing(true);
    let call =
      "/reports/ExportSentMessagesStatus?sortBy=SentDate&sortDir=SentDate&fileName=" +
      newFileName +
      "&reportType=2";
    const res = await CallAPI(call, refObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      $("#InputDownloadModal").modal("hide");
      $("#downloadProgressModal").modal("show");
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.message;
      let str = "<div>";
      str += msg + "</div>";
      SetProcessing(false);
    }
  };
  const headers = [
    {
      label: "User Name",
      key: "userNameDisplay",
    },
    { label: "Account Name", key: "accountName" },
    { label: "Direct Email", key: "directMail" },
    { label: "Last Login", key: "dateLastLogin" },
    { label: "Last Modified", key: "dateModified" },
    { label: "Modified By", key: "modifiedByDisplay" },
    { label: "Date Created", key: "dateCreated" },
    { label: "Created By", key: "createdByDisplay" },
    { label: "Organization", key: "orgName" },
  ];
  return (
    <div ref={componentRef}>
      <div className="HeaderUserActivityTool">
        <header>
          <div className="title-label">
            <i
              class="fa-solid fa-users sp-margin5"
              alt="Send messag status icon"
            ></i>{" "}
            User Activity{" "}
          </div>
          <aside className="mid-header-bar spacer-inline sp-mx5">
            <ReportsDropdown />
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              //data-target="#userActivitySearchModal"
              onClick={(e) => {
                SetSharedObject("UserActiviyType", "reg");
                $("#userActivitySearchModal").modal("show");
              }}
              data-toggle="modal"
              title="Search"
              alt="search for message forwarding"
            >
              <i className="bi bi-search" alt="search icon"></i>
            </button>
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              onClick={(e) => {
                bulkDownLoad();
              }}
              title="Bulk Download"
            >
              <i className="bi bi-box-arrow-down" alt="bulk download icon"></i>
            </button>
            <span className="SharedTools">
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                title="File Download"
                // onClick={(e) => {
                //   if (count > 0) {
                //     downLoad();
                //   }
                // }}
              >
                {count > 0 ? (
                  <CSVLink
                    filename="ListUserActivity.csv"
                    data={userObj}
                    headers={headers}
                  >
                    <i className="bi bi-download" alt="file download icon"></i>
                  </CSVLink>
                ) : (
                  <i className="bi bi-download" alt="file download icon"></i>
                )}
              </button>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                title="Refresh Page"
                onClick={(e) => {
                  if (count > 0) refreshPage();
                }}
              >
                <i
                  className="bi bi-arrow-clockwise"
                  alt="refresh page icon"
                ></i>
              </button>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                title="Print page"
                onClick={(e) => {
                  if (count > 0) handlePrint();
                }}
              >
                <i className="bi bi-printer" alt="printer icon"></i>
              </button>
            </span>
          </aside>
        </header>
      </div>
      <div className="ListMessageSent">
       <section className="grid-header-bar" aria-labelledby="Grid Header Bar">
        {userRole !== "SES ADMINISTRATOR" ? null : (
          <section>
            <div className="spacer-inline spacer-margin1">
              <span className="ft-wt">Domain:</span>
              <span className="sp-margin12">
                {sharedObject?.messageStatusSearch?.DomainName
                  ? userObj?.length > 0
                    ? sharedObject?.messageStatusSearch?.DomainName
                    : null
                  : null}
              </span>
            </div>
            <div className="spacer-inline">
              <span className="ft-wt">Customer:</span>
              <span className="sp-margin12">
                {sharedObject?.messageStatusSearch?.VendorName
                  ? userObj?.length > 0
                    ? sharedObject?.messageStatusSearch?.VendorName
                    : null
                  : null}
              </span>
            </div>
          </section>
        )}
        <SharedMsg />
        </section>
        <section className="grid-layout">
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                rows={25}
                paginator
                selectionPageOnly
                rowsPerPageOptions={[25, 50, 75]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
                sortField="dateCreated"
                sortOrder={-1}
              >
                <Column
                  field="nameDisplay"
                  header="User Name"
                  className="print-col"
                  sortable
                ></Column>
                <Column
                  field="accountName"
                  header="Account Name"
                  className="print-col"
                  sortable
                ></Column>
                <Column
                  field="directMail"
                  header="Direct Email"
                  className="truncate"
                  sortable
                ></Column>
                <Column
                  field="dateLastLogin"
                  header="Last Login"
                  className="w-md8"
                  body={sentMessageTemplate}
                  sortable
                ></Column>
                <Column
                  field="dateModified"
                  header="Last Modified"
                  className="w-md8"
                  sortable
                  body={formatDateAccepted}
                ></Column>
                <Column
                  field="modifiedByDisplay"
                  header="Modified By"
                  className="print-col"
                  sortable
                ></Column>
                <Column
                  field="dateCreated"
                  header="Date Created"
                  className="w-md8"
                  sortable
                  body={formatDateConfirmed}
                ></Column>
                <Column
                  field="createdByDisplay"
                  header="Created By"
                  className="print-col"
                  sortable
                ></Column>
                <Column
                  field="orgName"
                  header="Organization"
                  className="print-col"
                  sortable
                ></Column>
              </DataTable>
              {/* <Paginator
                first={first}
                rows={rows}
                totalRecords={count}
                onPageChange={onPageChange}
              />
              <span className="">
                {first} - {last} of {count}
              </span> */}
            </div>
          ) : (
            <section className="empty-grid">
              There are currently no search results.
            </section>
          )}
        </section>

        {/*Failed Reports Modal*/}
        <div
          className="modal fade"
          id="FlReportModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="Failed Report Extended Status"
          aria-hidden="false"
          //style={{ width: "820px" }}
        >
          <div className="modal-dialog" style={{ maxWidth: "865px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title " id="myModalLabel">
                  History for {activityHistory?.userNameDisplay}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="false">&times;</span>
                </button>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  {" "}
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/*Create New Filename Modal*/}
        <div
          className="modal fade"
          id="InputDownloadModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="CreateNewFilename"
          aria-hidden="false"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title " id="myModalLabel">
                  {" "}
                  Download Filename{" "}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="false">&times;</span>{" "}
                </button>
              </div>
              <div className="modal-body">
                <div className="modal-content-body">
                  <div className="descript-container">
                    Enter a new name to identify your download file once it has
                    been queued in the download status page.
                  </div>
                  <div className="modal-content-form">
                    <label for="NewFileName">Create a new file name</label>
                    <input
                      className="form-control"
                      name="NewFileName"
                      value={newFileName}
                      onChange={(el) => setNewFileName(el.target.value)}
                    />
                    {submInputFlag && newFileName === "" ? (
                      <div className="alert alert-danger">Required!</div>
                    ) : null}

                    <div className="field-wrapper sp-margin3 descript-container">
                      Downloading may take several minutes to hours depending on
                      the number of records and timeframe of the report.
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={QueueDownload}
                >
                  {" "}
                  Queue Download{" "}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  {" "}
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
        {processing ? <div className="loading"></div> : null}
      </div>
    </div>
  );
};

ListUserActivity.defaultProps = {};

export default ListUserActivity;
